/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-28 15:36:40
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Import Router Modules */
import cloudStorageRouter from './Modules/cloudStorage'
// import cloudConsultationRouter from './Modules/cloudConsultation'
import cloudTeachingRouter from './Modules/cloudTeaching'
import cloudServiceRouter from './Modules/cloudService'
import maiRouter from './Modules/mai'
import statisticsRouter from './Modules/statistics'
import appRouter from './Modules/app'
import systemRouter from './Modules/system'

//定义组件名称和组件对象的map对象
 export const componentMap = {

 }

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor','user']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
    meta:{
    }
  },

  // 用户设置
  { 
    path: '/userSetting',
    component: Layout,
    redirect: '/userSetting/accountSetting',
    children: [
      {
        path: 'accountSetting',
        name: 'accountSetting',
        component: () => import('@/views/userSetting/accountSetting/index'),
        meta: {
          title: 'accountSetting'
        }
      },
      {
        path: 'modifyPassword',
        name: 'modifyPassword',
        component: () => import('@/views/userSetting/modifyPassword/index'),
        meta: {
          title: 'modifyPassword'
        }
      },
      {
        path: 'authentication',
        name: 'authentication',
        component: () => import('@/views/userSetting/authentication/index'),
        meta: {
          title: 'authentication'
        }
      },
    ],
    hidden: true
  },

  // 用户主页
  {
    path: '/',
    component: Layout,
    redirect: '/mainpage',
    children: [
      {
        path: 'mainpage',
        name: 'mainpage',
        component: () => import('@/views/home/index'),
        meta: {
          title: 'home',
          icon: 'home'
        }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 云存储
  cloudStorageRouter,
  // 云咨询
  // cloudConsultationRouter,
  // 云教学
  cloudTeachingRouter,
  // 云客服
  cloudServiceRouter,
  // 麦粒医生
  maiRouter,
  // 数据统计
  statisticsRouter,
  // 应用管理
  appRouter,
  // 系统管理
  systemRouter,

  // 联系我们
  {
    path: '/cloud_contactus_page',
    component: Layout,
    redirect: '/cloud_contactus_page',
    children: [
      {
        path: 'cloud_contactus_page',
        name: 'cloud_contactus_page',
        component: () => import('@/views/contactUs/index'),
        meta: { title: 'contactUs', icon: 'contactUs', roles:['超级管理员','普通用户','专家','系统管理员','Super Admin','Common User'] }
      }
    ]
  },

  //官方网址
  {
    path: 'cloud_offical_page',
    component: Layout,
    children: [
      {
        path: 'http://www.siui.com.cn/ax/',
        meta: { title: 'officialWebsite', icon: 'link', roles:['超级管理员','普通用户','专家','系统管理员','Super Admin','Common User']}
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
